import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import PresenzeWidget from "../../widgets/PresenzeWidget";
import getLezioni from "../../services/getLezioni";
import getStudenti from "../../services/getStudenti";
import getInsegnanti from "../../services/getInsegnanti";
import getMaterie from "../../services/getMaterie";
import getSessioniLezione from "../../services/getSessioniLezione";
import moment from "moment";

export default class GestionePresenze extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      lezione: undefined,
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
    };

    this.grid = 2;

    this.pageTitle = "Gestione Presenze";

    this.state = {};
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentLezione = cookies.get("currentLezione", { path: "/" });
    this.currentMateria = cookies.get("currentMateria", { path: "/" });

    this.lezioni = await getLezioni(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.materie = await getMaterie(username, token);

    const lezione = this.lezioni.find(
      (l) => Number(l.id) == Number(currentLezione),
    );
    if (lezione == undefined) return;

    this.studenti = await getStudenti(username, token);
    const splittedDate = lezione.data.split(" ");

    // Formatta la data nel formato DD/MM/YYYY
    const dataFormattata = moment(splittedDate[0], "YYYY-MM-DD").format(
      "DD/MM/YYYY",
    );

    // Carica le sessioni per questa lezione
    const sessioni = await getSessioniLezione(username, token, lezione.id);

    if (sessioni && sessioni.length > 0) {
      // 🔀 MEZZA GIORNATA: costruisci docente/materia/orario dalle sessioni
      const nomiInsegnantiPerSessione = sessioni.map((sess) => {
        if (sess.id_insegnanti) {
          const ids = sess.id_insegnanti.split(",").map((id) => id.trim());
          const selezionati = this.insegnanti.filter((ins) =>
            ids.includes(ins.id.toString()),
          );
          return (
            selezionati.map((ins) => `${ins.nome} ${ins.cognome}`).join(", ") ||
            "-"
          );
        }
        return "-";
      });

      const nomiMateriePerSessione = sessioni.map((sess) => {
        if (sess.id_materia) {
          const ids = sess.id_materia.split(",").map((id) => id.trim());
          const selezionate = this.materie.filter((materia) =>
            ids.includes(materia.id.toString()),
          );
          return (
            selezionate.map((materia) => materia.materia).join(", ") || "-"
          );
        }
        return "-";
      });

      const orariPerSessione = sessioni.map((sess) => {
        if (sess.ora_inizio && sess.ora_fine) {
          return `${sess.ora_inizio}-${sess.ora_fine}`;
        } else if (sess.ora_inizio) {
          return sess.ora_inizio;
        }
        return "-";
      });

      this.setState({
        materia: nomiMateriePerSessione.join(" / "),
        insegnante: nomiInsegnantiPerSessione.join(" / "),
        data: dataFormattata,
        orario: orariPerSessione.join(" / "),
        lezione,
      });
    } else {
      // 📋 LEZIONE INTERA: logica originale
      const insegnanteIds = (lezione.id_insegnanti || "")
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      const insegnantiSelezionati = this.insegnanti.filter((ins) =>
        insegnanteIds.includes(ins.id.toString()),
      );

      const nomiInsegnanti = insegnantiSelezionati
        .map((ins) => `${ins.nome} ${ins.cognome}`)
        .join(", ");

      // Recupera il nome della materia usando id_materia
      let nomeMateria = "";
      if (lezione.id_materia) {
        const idMaterie = lezione.id_materia.split(",").map((id) => id.trim());
        const materieSelezionate = this.materie.filter((materia) =>
          idMaterie.includes(materia.id.toString()),
        );
        const nomiMaterie = materieSelezionate.map(
          (materia) => materia.materia,
        );
        nomeMateria = nomiMaterie.join(", ");
      }

      this.setState({
        materia:
          nomeMateria || lezione.str_materia || "Nessuna materia specificata",
        insegnante: nomiInsegnanti,
        data: dataFormattata,
        orario: splittedDate[1],
        lezione,
      });
    }
  }

  render() {
    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    if (this.state.lezione == undefined) return <div />;
    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />

          <div>
            <b>Docente: </b>
            {this.state.insegnante}
          </div>
          <div>
            <b>Materia: </b>
            {this.state.materia}
          </div>
          <div>
            <b>Data: </b>
            {this.state.data}
          </div>
          <div>
            <b>Orario: </b>
            {this.state.orario}
          </div>

          <PresenzeWidget
            corsi={[
              ...new Set(
                (
                  this.state.lezione.altri_corsi +
                  ";" +
                  this.state.lezione.id_corso
                ).split(";"),
              ),
            ]}
            lezione={this.state.lezione}
          />
        </LoadingOverlay>
      </>
    );
  }
}
